<dx-tab-panel
  class="chartFormBodyTab"
  [(selectedIndex)]="selectedTab"
  itemTitleTemplate="translatedTemplate"
  style="height: 100%; display: flex;">
  <div *dxTemplate="let title of 'translatedTemplate'">
    <span>{{ title.caption | translate }}</span>
  </div>
  <dxi-item caption="CHART_CREATION.METRIC_TAB">
    <dx-scroll-view direction="vertical">
      <div class="chartFormBody">
        <app-partition-selector
          [(selectedPartition)]="dashboardService.selectedPartitionIds[0]">
        </app-partition-selector>
        <div class="sideBySideLists">
          <app-device-selector
            #deviceSelectorComponent
            [(selectedDeviceId)]="dashboardService.selectedDeviceIds[0]"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
            class="flexFill">
          </app-device-selector>
          <app-metric-selector
            (selectedMetricIdsChange)="checkGroupValidation(); editMode = true;"
            [(selectedMetricIds)]="selectedMetricIds"
            [(selectedMetrics)]="selectedMetrics"
            [deviceList]="deviceSelectorComponent.deviceList"
            [inputDisplayMode]="'table'"
            [isDataForChart]="true"
            [selectedDeviceId]="dashboardService.selectedDeviceIds[0]"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
            class="flexFill"
            style="overflow: hidden">
          </app-metric-selector>
        </div>
      </div>
    </dx-scroll-view>
  </dxi-item>
  <dxi-item caption="CHART_CREATION.TAB_DETAIL">
    <div class="chartFormBody">
      <div class="flexFill flexColumn" style="overflow: hidden">
        <dx-form
          #editGroupForm
          (onFieldDataChanged)="checkGroupValidation();"
          [(formData)]="copiedUserMetricGroup"
          [labelMode]="'outside'">
          <dxi-item [editorOptions]="nameInputFieldOptions" dataField="name">
            <dxi-validation-rule type="required"></dxi-validation-rule>
            <dxo-label [text]="translate.instant('CHART_CREATION.NAME')"></dxo-label>
          </dxi-item>
        </dx-form>
        <app-chart-metrics-table
          (dataChanged)="checkGroupValidation(); editMode = true"
          [selectedMetrics]="selectedMetrics"
          class="flexFill"
          style="overflow: hidden">
        </app-chart-metrics-table>
      </div>
    </div>
  </dxi-item>
</dx-tab-panel>
